module.exports = __webpack_public_path__ + "static/img/t5.3b84d1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/t5.png
// module id = 2lKP
// module chunks = 1